import { render } from 'preact';
import App from './components/App';

// Mount Preact app to the DOM
render(<App />, document.getElementById('app'));